import React from 'react';
import RatingsTable from "../RatingsTable/RatingsTableView";

const RatingsSection = React.memo(({ 
  selectedGuide,
  setSelectedGuide,
  clubData 
}) => {
  return (
    <div className="RatingsTable">
      <RatingsTable
        holes={selectedGuide.holes}
        teeRatings={selectedGuide.teeRatings}
        selectedGuide={selectedGuide}
        setSelectedGuide={setSelectedGuide}
        clubData={clubData}
      />
    </div>
  );
});

RatingsSection.displayName = 'RatingsSection';

export default RatingsSection; 